import { Button, Container, Typography } from '@cleartrip/ct-design-components'
import { AlertErrorIcon } from './icons'
import {
    FIND_ANOTHER_FLIGHT_CTA,
    FLIGHT_UNAVAILABLE_ICON_COLORS,
    FLIGHT_UNAVAILABLE_SUBTITLE,
    FLIGHT_UNAVAILABLE_TITLE
} from './constants'

export type FlightUnavailableAlertProps = {
    onFindAnotherFlight?: () => void
    title?: string
    subTitle?: string
}

// Figma: node-id 3306-34699
const FlightUnavailableAlert = ({
    onFindAnotherFlight = () => {},
    title = FLIGHT_UNAVAILABLE_TITLE,
    subTitle = FLIGHT_UNAVAILABLE_SUBTITLE
}: FlightUnavailableAlertProps) => (
    <Container className="flex flex-column flex-middle flex-gap-6 pt-6 pb-4 px-4 w-100p">
        <Container className="flex flex-column flex-middle flex-gap-4 w-100p">
            <Container
                className="flex flex-middle flex-center flex-shrink-0"
                css={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '60px',
                    background: FLIGHT_UNAVAILABLE_ICON_COLORS.background
                }}
            >
                <AlertErrorIcon />
            </Container>
            <Container className="flex flex-column flex-middle flex-gap-2 w-100p">
                <Typography variant="HM2" className="ta-center">
                    {title}
                </Typography>
                {subTitle ? (
                    <Typography variant="P2" color="subheading" className="ta-center">
                        {subTitle}
                    </Typography>
                ) : null}
            </Container>
        </Container>
        <Container className="flex flex-column w-100p">
            <Button variant="contained" color="primary" size="small" isFullWidth onClick={onFindAnotherFlight}>
                {FIND_ANOTHER_FLIGHT_CTA}
            </Button>
        </Container>
    </Container>
)

export default FlightUnavailableAlert
